import { computed, Directive, forwardRef, inject } from "@angular/core";
import { TooltipResponse } from "../../../services/tooltip.service";
import { S25ItemComponent } from "../s25.item.component";
import { Item } from "../../../pojo/Item";

@Directive({
    host: {
        "[class.popoverroot]": "s25Item.initPopOver() && !s25Item.loading()",
        "(contextmenu)": "handleContextMenu($event)",
    },
})
export class S25ItemTooltip<TooltipType extends TooltipResponse> {
    // Get a handle on the item component that created this tooltip
    readonly s25Item: S25ItemComponent = inject(forwardRef(() => S25ItemComponent));
    readonly item = computed(() => this.s25Item.data()?.item as TooltipType["item"] | undefined);
    readonly loaded = computed(() => this.s25Item.initPopOver() && !this.s25Item.loading());

    protected readonly Item = Item;

    handleContextMenu(event: MouseEvent) {
        if (this.loaded() && this.item()) {
            this.s25Item.openContextMenu(event);
        }
    }
}
